import { Component } from 'react';
import { Row, Col, Card, Alert } from 'react-bootstrap';

import { toast } from 'react-toastify';
import Layout from '../DashboardLayout';
import Loader from '../../components/Loader';

import SettingsTabs from '../../components/settings/Tabs';
import EmailSummariesForm from '../../components/settings/EmailSummariesForm';
import EmailNotificationSettings from '../../components/settings/EmailNotificationSettings';
import AddMembers from '../../components/settings/AddMembers';
import AddNotificationRecipients from '../../components/settings/AddNotificationRecipients';
import {
  settingsService,
  teamService,
  notificationService,
} from '../../services';
import { updateLocalStorage } from '../../helpers';
import {
  UPDATE_FAILURE_ERROR,
  LOCAL_STORAGE_USER_DATA,
  SETTINGS_SUMMMARIES,
} from '../../constants';

class EmailSummaries extends Component {
  userdata = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA));

  /* Save the original list to manipulate dropdown when user is deleted fron email list */
  teamListOrginal = [];

  pageHeading = {
    preTitle: 'Settings',
    title: 'Email Summaries',
  };

  state = {
    isSubmitting: false,
    isFetchingNotifications: false,
    settingsList: [],
    teamList: [],
    dailySummaryNoWorkSession: this.userdata.dailySummaryNoWorkSession,
    teamMembersList: [],
    recipientUsers: [],
    notifyTeamAdminsOnly: false,
  };

  componentDidMount() {
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));
    /* fetch the email settings for the owner
      Remove mail field from the keys, to match with the edit settings api keys
    */
    settingsService
      .get_email_settings(localStorage.getItem('teamOwnerId'))
      .then((resp) => {
        const newArray = resp.data.map((item) => {
          const newItem = {};
          Object.keys(item).forEach((key) => {
            if (key === 'projectId') {
              /* projectId key should be projectIds for edit/add API */
              newItem.projectIds = item[[key]];
            } else {
              /* edit/add API json keys shouldn't contain 'Mail' text */
              /* dailyMailCSV keeps its key as-is; others strip 'Mail' */
              const newKey =
                key === 'dailyMailCSV' ? key : key.replace('Mail', '');

              const found = ['daily', 'weekly', 'bimonthly'].find((v) =>
                v.includes(newKey)
              );
              if (found || key === 'dailyMailCSV') {
                /* Api values are having null instead of false, which wont work in formik
                  and api doesn't accept
                */
                if (item[[key]]) {
                  newItem[newKey] = item[[key]];
                } else {
                  newItem[newKey] = false;
                }
              } else {
                newItem[newKey] = item[[key]];
              }
            }
          });
          newItem.id = item._id;
          return newItem;
        });
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
          settingsList: newArray,
        }));
      })
      .then(() => {
        /* Fetch the team members of the owner */
        this.getTeamData();
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
        }));
      });

    this.getEmailNotificationSettings();
  }

  getEmailNotificationSettings = () => {
    this.setState((state) => ({
      ...state,
      isFetchingNotifications: true,
    }));
    notificationService
      .get_email_settings_notification_list({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
      })
      .then((resp) => {
        if (resp.data) {
          this.setState((state) => ({
            ...state,
            recipientUsers: [...resp.data.recipientUsers],
            notifyTeamAdminsOnly: resp.data.notifyTeamAdminsOnly,
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isFetchingNotifications: false,
        }));
      });
  };

  handleAddNotificationRecipients = (data) => {
    this.setState((state) => ({
      ...state,
      isFetchingNotifications: true,
    }));
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      users: data?.members?.map((item) => ({
        userId: item,
        notifications: [],
      })),
    };
    notificationService
      .add_notification_recipient(params)
      .then((resp) => {
        if (resp.data) {
          this.setState((state) => ({
            ...state,
            recipientUsers: [...resp.data.recipientUsers],
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isFetchingNotifications: false,
        }));
      });
  };

  handleUpdateNotificationRecipients = (data) => {
    this.setState((state) => ({
      ...state,
      isFetchingNotifications: true,
    }));
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      users:
        data.recipientUsers?.length > 0
          ? data.recipientUsers.map((rUser) => {
              const item = {
                userId: rUser.userId._id,
                notifications:
                  rUser.notifications?.length > 0
                    ? rUser.notifications.map((notification) => ({
                        type: notification.type,
                        channels: notification.channels || ['email', 'in-app'],
                      }))
                    : [],
              };
              return item;
            })
          : [],
    };
    notificationService
      .update_notification_recipients(params)
      .then((resp) => {
        if (resp.data) {
          this.setState((state) => ({
            ...state,
            recipientUsers: [...resp.data.recipientUsers],
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isFetchingNotifications: false,
        }));
      });
  };

  handleRemoveNotificationRecipient = (userId) => {
    this.setState((state) => ({
      ...state,
      isFetchingNotifications: true,
    }));
    notificationService
      .delete_notification_recipient({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        userId,
      })
      .then((resp) => {
        if (resp.data) {
          this.setState((state) => ({
            ...state,
            recipientUsers: [...resp.data.recipientUsers],
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isFetchingNotifications: false,
        }));
      });
  };

  handleNotifyTeamAdminsOnlySetting = (value) => {
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));

    notificationService
      .update_notify_team_admins_only({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        notifyTeamAdminsOnly: value.target.checked,
      })
      .then((resp) => {
        if (resp.data) {
          this.setState((state) => ({
            ...state,
            notifyTeamAdminsOnly: value.target.checked,
          }));

          if (value.target.checked) {
            toast.success(SETTINGS_SUMMMARIES.NOTIFY_TEAM_ADMINS);
          } else {
            toast.success(SETTINGS_SUMMMARIES.NOTIFY_ALL_USERS);
          }
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
        }));
      });
  };

  getEmailSettings = () => {
    settingsService
      .get_email_settings(localStorage.getItem('teamOwnerId'))
      .then((resp) => {
        const newArray = resp.data.map((item) => {
          const newItem = {};
          Object.keys(item).forEach((key) => {
            if (key === 'projectId') {
              /* projectId key should be projectIds for edit/add API */
              newItem.projectIds = item[[key]];
            } else {
              /* dailyMailCSV keeps its key as-is; others strip 'Mail' */
              const newKey =
                key === 'dailyMailCSV' ? key : key.replace('Mail', '');

              const found = ['daily', 'weekly', 'bimonthly'].find((v) =>
                v.includes(newKey)
              );
              if (found || key === 'dailyMailCSV') {
                /* Api values are having null instead of false, which wont work in formik
                  and api doesn't accept
                */
                if (item[[key]]) {
                  newItem[newKey] = item[[key]];
                } else {
                  newItem[newKey] = false;
                }
              } else {
                newItem[newKey] = item[[key]];
              }
            }
          });
          newItem.id = item._id;
          return newItem;
        });
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
          settingsList: newArray,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
        }));
      });
  };

  getTeamData = () => {
    /* Fetch the team members of the owner */
    teamService
      .get_team_members_data({
        teamOwnerId: localStorage.getItem('teamOwnerId'), // @ToDo: Move this to reducer or react-context API
        summaryList: true,
        filter: '{ "memberStatus": "active" }',
      })
      .then((response) => {
        const { members } = response.data;
        const { settingsList } = this.state;
        /* remove users from dropdown, already existing in email list */
        const result = members.filter(function (o1) {
          return !settingsList.some(function (o2) {
            return o1.email === o2.email;
          });
        });

        this.setState((state) => ({
          ...state,
          teamList: result,
          isSubmitting: false,
          teamMembersList: [...members],
        }));

        this.teamListOrginal = members;
      });
  };

  /* update email list state array and trigger api to add user to email settings */
  handleListUpdate = (formValues) => {
    const newMembers = [];
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));

    if (formValues) {
      if (formValues.addExistingTeamMembers) {
        formValues.addExistingTeamMembers.forEach((elem) => {
          newMembers.push({
            _id: 0,
            id: 0,
            projectIds: null,
            email: elem,
            daily: false,
            weekly: false,
            biMonthly: false,
            ownerId: localStorage.getItem('teamOwnerId'),
          });
        });
      }
      if (formValues.addNewTeamMembers)
        formValues.addNewTeamMembers
          .filter((item) => item.email !== '')
          .forEach((elem) => {
            newMembers.push({
              _id: 0,
              id: 0,
              projectIds: null,
              email: elem.email,
              daily: false,
              weekly: false,
              biMonthly: false,
              ownerId: localStorage.getItem('teamOwnerId'),
            });
          });

      /* send api request to add new user to email list */
      const data = {
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        settings: newMembers,
      };

      settingsService
        .update_email_settings(data, 'POST')
        .then((succData) => {
          if (succData.status) {
            toast.success(SETTINGS_SUMMMARIES.MEMBER_ADD);
            this.getEmailSettings();
            const { teamList } = this.state;

            /* remove users from dropdown, added to email list */
            const result = teamList.filter(function (o1) {
              return !succData.data.some(function (o2) {
                return o1.email === o2.email;
              });
            });

            /* add new user(s) to state array of email listing
            remove from member dropdown list
          */
            this.setState((state) => ({
              ...state,
              teamList: result,
            }));
          }
        })
        .catch(() => {
          toast.error(UPDATE_FAILURE_ERROR);
        })
        .finally(() => {
          this.setState((state) => ({
            ...state,
            isSubmitting: false,
          }));
        });
    }
  };

  /* submit delete request for one settings */
  handleDeleteSummary = (id) => {
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));

    const data = {
      ownerId: localStorage.getItem('teamOwnerId'),
      id,
    };
    settingsService
      .delete_email_settings(data)
      .then(() => {
        this.getEmailSettings();
        const { settingsList } = this.state;
        const newMembers = settingsList.filter(
          (el) => el.id !== id
        ); /* remove id from state array */

        /* return elements found in new members to update dropdown */
        const memDropDown = this.teamListOrginal.filter(function (o1) {
          return !newMembers.find((element) => element.email === o1.email);
        });

        this.setState((state) => ({
          ...state,
          teamList: [...memDropDown],
          isSubmitting: false,
        }));

        toast.success(SETTINGS_SUMMMARIES.MEMBER_DEL);
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
        }));
        toast.error(UPDATE_FAILURE_ERROR);
      });
  };

  /* Updating options of added users */
  handleUpdateSummaries = (values) => {
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));

    if (values.settingsList.length > 0) {
      const data = {
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        settings: values.settingsList,
      };

      settingsService
        .update_email_settings(data, 'PATCH')
        .then((response) => {
          if (response.status) {
            this.getEmailSettings();
            toast.success(SETTINGS_SUMMMARIES.MEMBER_EDIT);
          }
        })
        .catch(() => {
          this.setState((state) => ({
            ...state,
            isSubmitting: false,
          }));

          toast.error(UPDATE_FAILURE_ERROR);
        });
    }
  };

  /* on click of checkbox */
  handleNoSummaryChange = (value) => {
    this.setState((state) => ({
      ...state,
      isSubmitting: true,
    }));

    settingsService
      .user_update({ dailySummaryNoWorkSession: value.target.checked })
      .then(() => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
          dailySummaryNoWorkSession: value.target.checked,
        }));

        /* update flag in local storage */
        updateLocalStorage({ dailySummaryNoWorkSession: value.target.checked });

        if (value.target.checked) {
          toast.success(SETTINGS_SUMMMARIES.DAILY_SUMMARY);
        } else {
          toast.success(SETTINGS_SUMMMARIES.NO_DAILY_SUMMARY);
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isSubmitting: false,
        }));

        toast.error(UPDATE_FAILURE_ERROR);
      });
  };

  render() {
    const {
      isSubmitting,
      isFetchingNotifications,
      settingsList,
      teamList,
      dailySummaryNoWorkSession,
      teamMembersList,
      recipientUsers,
      notifyTeamAdminsOnly,
    } = this.state;

    return (
      <Layout pageHeading={this.pageHeading}>
        {(isSubmitting || isFetchingNotifications) && (
          <Loader contentAreaOnly />
        )}
        <Row className="justify-content-center">
          <Col className="col-12 col-lg-10 col-xl-8">
            <SettingsTabs selectedTab={this.pageHeading.title} />
            <div className="tab-content">
              <div className="tab-pane show active">
                <section>
                  <Card>
                    <Card.Header>
                      <h4 className="card-header-title">Report Recipients</h4>
                    </Card.Header>
                    <Card.Body>
                      <AddMembers
                        handleListUpdate={this.handleListUpdate}
                        teamList={teamList}
                      />
                    </Card.Body>
                    <Row>
                      <Col>
                        <hr className="m-0" />
                        <div className="custom-control custom-checkbox px-4 py-3">
                          <label
                            className="custom-control-label"
                            htmlFor="noWorksession"
                          >
                            <input
                              className="form-check-input form-check-border m-2"
                              id="noWorksession"
                              type="checkbox"
                              defaultChecked={dailySummaryNoWorkSession}
                              style={{ float: 'left' }}
                              onChange={this.handleNoSummaryChange}
                            />
                            <div
                              style={{
                                overflow: 'hidden',
                                width: 'auto',
                                marginTop: '3px',
                              }}
                            >
                              <strong>
                                Send daily summary even if no worksessions were
                                logged
                              </strong>
                            </div>
                          </label>
                        </div>
                        <hr className="m-0" />
                      </Col>
                    </Row>

                    {settingsList.length > 0 && (
                      <EmailSummariesForm
                        settingsList={settingsList}
                        handleDelete={this.handleDeleteSummary}
                        handleAddEdit={this.handleUpdateSummaries}
                      />
                    )}
                  </Card>
                </section>
                <section>
                  <Card>
                    <Card.Header>
                      <h4 className="card-header-title">
                        Notification Recipients
                      </h4>
                    </Card.Header>
                    <Card.Body>
                      <Alert variant="light">
                        <p>
                          Use these settings to control who receives
                          notifications within your organization.
                        </p>
                        <ul className="mb-0">
                          <li>
                            <small>
                              <strong>Default Behavior:</strong> Notifications
                              are sent to account owners and all eligible
                              managers and supervisors.
                            </small>
                          </li>
                          <li>
                            <small>
                              <strong>Custom Recipients:</strong> Add specific
                              users to the below "recipient list" to limit
                              notifications to only those individuals.
                            </small>
                          </li>
                          <li>
                            <small>
                              <strong>Team Group Admin:</strong> Enable this
                              option to restrict notifications to group
                              administrators who are included in the below
                              "recipient list".
                            </small>
                          </li>
                          <li>
                            <small>
                              <strong>Important:</strong> If no recipients are
                              specified, the system will automatically send
                              notifications to account owner and all eligible
                              managers and supervisors.
                            </small>
                          </li>
                        </ul>
                      </Alert>
                      <AddNotificationRecipients
                        teamMembersList={teamMembersList}
                        recipientUsers={recipientUsers}
                        handleAddRecipients={
                          this.handleAddNotificationRecipients
                        }
                      />
                    </Card.Body>

                    {recipientUsers.length > 0 && (
                      <>
                        <Row>
                          <Col>
                            <hr className="m-0" />
                            <div className="custom-control custom-checkbox px-4 py-3">
                              <label
                                className="custom-control-label"
                                htmlFor="onlyTeamGroupAdmins"
                              >
                                <input
                                  className="form-check-input form-check-border m-2"
                                  id="onlyTeamGroupAdmins"
                                  type="checkbox"
                                  defaultChecked={notifyTeamAdminsOnly}
                                  style={{ float: 'left' }}
                                  onChange={
                                    this.handleNotifyTeamAdminsOnlySetting
                                  }
                                />
                                <div
                                  style={{
                                    overflow: 'hidden',
                                    width: 'auto',
                                    marginTop: '3px',
                                  }}
                                >
                                  <strong>Notify only team group admins</strong>
                                </div>
                              </label>
                              <p
                                className="mb-0"
                                style={{
                                  marginLeft: '28px',
                                  marginTop: '-5px',
                                }}
                              >
                                <small>
                                  When enabled, email notifications will be sent
                                  only to team group admins (set under the Team{' '}
                                  {'>'}
                                  Team Groups page), instead of all users on the
                                  notification recipient list.
                                </small>
                              </p>
                            </div>
                            <hr className="m-0" />
                          </Col>
                        </Row>
                        <EmailNotificationSettings
                          recipientUsers={recipientUsers}
                          handleUpdateNotifications={
                            this.handleUpdateNotificationRecipients
                          }
                          handleRemoveNotificationRecipient={
                            this.handleRemoveNotificationRecipient
                          }
                        />
                      </>
                    )}
                  </Card>
                </section>
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
    );
  }
}
export default EmailSummaries;
